import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  PAYSLIPS_REPOSITORY,
  PayslipstRepository
} from '@app/domain/repositories/ptrab/payslips/payslips.repository.contract';
import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { BankData } from '@app/entities/models/ptrab/payslips/bank-data.model';
import { CarTransfer } from '@app/entities/models/ptrab/payslips/car-transfer.model';
import { DirectDebit } from '@app/entities/models/ptrab/payslips/direct-debit.model';
import { GarnishAmountPayslip, Garnishment } from '@app/entities/models/ptrab/payslips/garnishment.model';
import { Payslip } from '@app/entities/models/ptrab/payslips/payslip.model';

import { PayslipsUseCases } from './payslips.use-cases.contract';

export class PayslipsUseCasesImpl implements PayslipsUseCases {
  #payslipsRepository: PayslipstRepository = inject(PAYSLIPS_REPOSITORY);

  getPayslips(isEmployee: boolean): Observable<Payslip[]> {
    return this.#payslipsRepository.getPayslips(isEmployee);
  }

  getGarnishmentList(): Observable<Garnishment[]> {
    return this.#payslipsRepository.getGarnishmentList();
  }

  getCarTransferList(): Observable<CarTransfer[]> {
    return this.#payslipsRepository.getCarTransferList();
  }

  getDirectDebits(): Observable<DirectDebit[]> {
    return this.#payslipsRepository.getDirectDebits();
  }

  arePayslipsAvailable(showToast: boolean): Promise<boolean | null> {
    return this.#payslipsRepository.arePayslipsAvailable(showToast);
  }

  calculateGarnishPayslip(company_code: string): Observable<GarnishAmountPayslip> {
    return this.#payslipsRepository.calculateGarnishPayslip(company_code);
  }

  isDirectDebitCertificateAvaible(): Promise<boolean> {
    return this.#payslipsRepository.isDirectDebitCertificateAvaible();
  }

  modifyDirectDebit(directDebit: DirectDebit, authorization: TwoFactorAuthorization): Observable<DirectDebit> {
    return this.#payslipsRepository.modifyDirectDebit(directDebit, authorization);
  }

  getBankDataName(iban: string): Observable<BankData> {
    const ibanWithoutSpace: string = iban.replace(/\s+/g, '');
    return this.#payslipsRepository.getBankDataName(ibanWithoutSpace);
  }

  getCurrentStatus() {
    return this.#payslipsRepository.currentStatus;
  }
}
